import { z } from 'zod';
import { Priority, Severity, TicketType } from './enums.js';
import { ReporterContact } from './ticket.js';
/**
 * Legacy external intake contract (BR-003, §8.1).
 *
 * POST /api/intake/requests
 * Required: type, title, description, reporterContact (for API-key / customer_support callers).
 * Optional: priority, severity, projectId, productArea, customer identifiers.
 *
 * This schema is the frozen external contract. Changing it is a breaking change
 * for existing Waypoint/n8n consumers and must be guarded by contract tests.
 */
export const IntakeCreateRequest = z.object({
    // Required per §8.1 (type, title, description, reporterContact). No silent default.
    type: TicketType,
    title: z.string().min(1, 'title is required'),
    description: z.string().min(1, 'description is required'),
    reporterContact: ReporterContact,
    priority: Priority.optional(),
    severity: Severity.optional(),
    projectId: z.string().optional(),
    productArea: z.string().optional(),
    customerId: z.string().optional(),
    customerName: z.string().optional(),
    /** External system's own id; enables idempotent create. */
    externalId: z.string().optional(),
    /**
     * Waypoint SupportTicket.id. When present the ticket is created as an
     * internal_bug linked back to Waypoint via externalId `waypoint:{id}`
     * (idempotent create + comment back-sync target).
     */
    waypointTicketId: z.string().optional(),
    onBehalfOfCustomerId: z.string().optional(),
    onBehalfOfCustomerName: z.string().optional(),
});
/**
 * PATCH /api/intake/requests/by-waypoint/:waypointTicketId — edit-mirror from
 * Waypoint. Nullable fields mean "clear"; a null priority is ignored (Atlas
 * has no unset priority).
 */
export const IntakeWaypointPatchRequest = z.object({
    title: z.string().min(1).optional(),
    description: z.string().min(1).optional(),
    priority: Priority.nullish(),
    severity: Severity.nullish(),
    productArea: z.string().nullish(),
});
//# sourceMappingURL=intake.js.map